<div class="rfq-product-info__wrapper">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="">Attach Product Files / Pictures</label>
          <button
            type="button"
            class="lum-button lum-button--secondary"
            (click)="fileInput.click()"
          >
            <lum-ui-icon
              color="#36363a"
              width="10"
              height="10"
              class="mr-2"
              icon="upload-button-2"
            ></lum-ui-icon>
            Upload
          </button>

          <input
            type="file"
            class="form-control"
            id="files"
            multiple
            (change)="onHandleFileInput($event)"
            style="display: none"
            #fileInput
          />
        </div>
        <div formArrayName="fileremarks">
          <table class="lum-table lum-table--classic striped">
            <thead>
              <tr>
                <th>File</th>
                <th>File Remarks/Description</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <ng-container
                *ngFor="let file of fileMarksControl?.controls; let idx = index"
              >
                <tr [formGroupName]="idx">
                  <td>
                    <img
                      [src]="file.value.previewSrc"
                      alt=""
                      width="60"
                      *ngIf="file.value.previewSrc != ''"
                    />
                    <span *ngIf="file.value.file">
                      {{ file.value.file.name }}
                    </span>
                  </td>
                  <td>
                    <span *ngIf="!file.value.file">{{ file.value | json }}</span>
                    <input
                      *ngIf="file.value.file"
                      class="lum-input"
                      type="text"
                      formControlName="remarks"
                    />
                  </td>
                  <td class="actions">
                    <button
                      class="lum-button lum-button--small"
                      (click)="onRemoveFile(idx)"
                    >
                      <lum-ui-icon
                        class="mr-2.5"
                        icon="delete-bin"
                        color="#ffffff"
                        width="16"
                        height="16"
                      ></lum-ui-icon>
                      Remove
                    </button>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </form>
</div>
